import { observer } from 'mobx-react';
import { FC } from 'react';
import { FormLabel } from 'react-bootstrap';
import values from 'stores/values';
import './style.scss';

interface OpenProgressProps {
    type?: 'fraction' | 'percent';
    showProgressLabel?: boolean; // 是否隐藏进度文案，现已全部默认隐藏
}

const OpenProgress: FC<OpenProgressProps> = props => {
    const { type = 'percent', showProgressLabel } = props;
    const { total, step, title, showProgressBar } = values;
    // 防止某些流程计算的时候,出现超过100%的情况, 这里限制最大的值为100
    const percentage = Math.min(Number((step / total).toFixed(2)) * 100, 100);

    return showProgressBar && total ? (
        <div className="open-progress-bar">
            {title && (
                <div className="op-title">
                    <FormLabel className="label-primary">{title}</FormLabel>
                </div>
            )}
            {showProgressLabel && (
                <span className="bubble" style={{ left: `${percentage}%` }}>
                    {type === 'percent' ? `${percentage}%` : `${step}/${total}`}
                </span>
            )}
            <div className="bar" style={{ width: `${percentage}%` }} />
        </div>
    ) : null;
};

export default observer(OpenProgress);
